// Mock data for Chango's Renovation website

export const contactInfo = {
  phone: "0471664418",
  email: "changos.renovation@gmail.com",
  location: "Bruxelles",
  hours: "7j/7 : 8h00 - 20h00"
};

export const services = [
  {
    id: 1,
    title: "Rénovation Complète",
    description: "Transformation totale de votre habitat, de la conception à la finition. Nous gérons tous les corps de métier pour une rénovation clé en main.",
    icon: "home",
    features: ["Plans et conception", "Gestion complète du projet", "Tous corps de métier", "Garantie décennale"]
  },
  {
    id: 2,
    title: "Cuisine & Salle de Bain",
    description: "Création d'espaces fonctionnels et esthétiques. Design personnalisé, installation sanitaire et électrique incluse.",
    icon: "chef-hat",
    features: ["Design sur-mesure", "Plomberie et électricité", "Carrelage et revêtements", "Meubles et équipements"]
  },
  {
    id: 3,
    title: "Électricité & Domotique",
    description: "Installation et rénovation électrique complète. Mise aux normes, domotique, éclairage LED et solutions économes en énergie.",
    icon: "zap",
    features: ["Mise aux normes", "Installation complète", "Domotique et automatisation", "Éclairage LED"]
  },
  {
    id: 4,
    title: "Plomberie & Sanitaire",
    description: "Tous travaux de plomberie, sanitaire et chauffage. Installation, dépannage et entretien par un professionnel expérimenté.",
    icon: "droplet",
    features: ["Installation sanitaire", "Dépannage rapide", "Chauffage central", "Détection de fuites"]
  },
  {
    id: 5,
    title: "Aménagements Intérieurs",
    description: "Optimisation et décoration d'espaces : cloisons, faux-plafonds, sols, peinture, menuiserie.",
    icon: "paintbrush",
    features: ["Cloisons et divisions", "Revêtements sols/murs", "Peinture décorative", "Menuiserie sur-mesure"]
  },
  {
    id: 6,
    title: "Dépannage & Urgences",
    description: "Service d'urgence 7j/7 pour vos dépannages. Électricité, plomberie, serrurerie : nous intervenons rapidement.",
    icon: "clock",
    features: ["Disponible 7j/7", "Intervention rapide", "Dépannage d'urgence", "Devis gratuit"]
  }
];

export const projects = [
  {
    id: 1,
    title: "Rénovation Maison Familiale - Uccle",
    category: "Rénovation Complète",
    description: "Transformation complète d'une maison des années 70 en un espace moderne et lumineux.",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&h=600&fit=crop",
    year: "2024"
  },
  {
    id: 2,
    title: "Extension Moderne - Woluwe",
    category: "Extension",
    description: "Agrandissement de 40m² avec grandes baies vitrées et terrasse.",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop",
    year: "2024"
  },
  {
    id: 3,
    title: "Cuisine Contemporaine - Ixelles",
    category: "Cuisine",
    description: "Création d'une cuisine ouverte avec îlot central et équipements haut de gamme.",
    image: "https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&h=600&fit=crop",
    year: "2023"
  },
  {
    id: 4,
    title: "Rénovation Appartement - Centre",
    category: "Rénovation",
    description: "Optimisation d'un appartement de 85m² avec redistribution des espaces.",
    image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&h=600&fit=crop",
    year: "2023"
  },
  {
    id: 5,
    title: "Salle de Bain Spa - Watermael",
    category: "Salle de Bain",
    description: "Transformation en espace bien-être avec douche à l'italienne et mobilier design.",
    image: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=800&h=600&fit=crop",
    year: "2023"
  },
  {
    id: 6,
    title: "Façade Rénovée - Etterbeek",
    category: "Façade",
    description: "Ravalement complet avec isolation extérieure et crépi contemporain.",
    image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&h=600&fit=crop",
    year: "2024"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie Dupont",
    location: "Uccle",
    rating: 5,
    text: "Équipe professionnelle et à l'écoute. Notre maison a été transformée au-delà de nos attentes. Travail soigné et respect des délais.",
    project: "Rénovation complète"
  },
  {
    id: 2,
    name: "Pierre Lemaire",
    location: "Woluwe-Saint-Lambert",
    rating: 5,
    text: "Excellente expérience du début à la fin. Chango's a géré notre extension avec professionnalisme. Je recommande vivement!",
    project: "Extension 35m²"
  },
  {
    id: 3,
    name: "Sophie Martin",
    location: "Ixelles",
    rating: 5,
    text: "Notre cuisine est magnifique! L'équipe a su comprendre nos besoins et proposer des solutions adaptées. Très satisfaits du résultat.",
    project: "Rénovation cuisine"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "15+ Ans d'Expérience",
    description: "Une expertise reconnue dans la rénovation et la construction à Bruxelles.",
    icon: "award"
  },
  {
    id: 2,
    title: "Équipe Qualifiée",
    description: "Des artisans certifiés et passionnés par leur métier.",
    icon: "users"
  },
  {
    id: 3,
    title: "Garanties & Assurances",
    description: "Tous nos travaux sont couverts par des garanties décennales.",
    icon: "shield-check"
  },
  {
    id: 4,
    title: "Devis Gratuit & Transparent",
    description: "Estimation détaillée sans engagement, sans frais cachés.",
    icon: "file-text"
  },
  {
    id: 5,
    title: "Suivi Personnalisé",
    description: "Un interlocuteur unique pour votre projet du début à la fin.",
    icon: "headphones"
  },
  {
    id: 6,
    title: "Respect des Délais",
    description: "Planification rigoureuse et engagement sur les dates.",
    icon: "clock"
  }
];

export const companyInfo = {
  name: "Chango's Renovation",
  tagline: "Votre partenaire de confiance pour tous vos projets de construction et rénovation",
  description: "Depuis plus de 15 ans, je mets mon expertise au service de projets de rénovation et de construction à Bruxelles et ses environs. J'ai débuté ma carrière en tant qu'électricien, un métier qui m'a permis d'acquérir rigueur, précision et sens du détail sur le terrain.",
  mission: "Au fil des années, j'ai élargi mes compétences à l'ensemble des corps de métier du bâtiment, développant une vision globale des projets de rénovation. Cette expérience m'a naturellement conduit à fonder Chango's Renovation, avec la volonté d'offrir un accompagnement complet, de la conception à la réalisation, avec un interlocuteur unique.",
  objective: "Aujourd'hui, mon objectif est simple : transformer vos espaces en lieux fonctionnels, durables et à votre image, en combinant savoir-faire artisanal, matériaux de qualité et respect de votre budget.",
  values: [
    "Qualité et excellence dans chaque réalisation",
    "Écoute et conseil personnalisé",
    "Transparence et honnêteté",
    "Respect de l'environnement",
    "Innovation et créativité"
  ]
};
